import { IQualification } from 'src/app/model/qualifications/iqualification';
import { IQualificationBasis } from 'src/app/model/qualifications/iqualification-basis';
import { QUALIFICATION_NAMES } from 'src/app/service/ansokan-form-builder/application-names';

export class QualificationFormatter {

    private static readonly FIELD_NAMES = [
        QUALIFICATION_NAMES.TYPE_NAME,
        QUALIFICATION_NAMES.ORIENTATION_NAME_OPTIONAL,
        QUALIFICATION_NAMES.SUBJECT_NAME_OPTIONAL,
        QUALIFICATION_NAMES.LANGUAGE_NAME_OPTIONAL,
    ];

    public static formatQualification(qualification: IQualification): string[] {
        return this.FIELD_NAMES.map((name) => qualification[name])
            .filter((value: string) => value !== null);
    }

    public static formatBases(bases: IQualificationBasis[]): string[] {
        return bases.map((basis) => this.formatBasis(basis));
    }

    private static formatBasis(basis: IQualificationBasis): string {
        let value = basis.typeName;
        if (basis.yearIntervals) {
            value += `. Åk ${basis.yearIntervals.join(', ')}`;
        }
        if (basis.fromYear && basis.toYear) {
            value += `. Åk ${basis.fromYear}-${basis.toYear}`;
        }
        return value;
    }

}
